import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { catalogBaseColumns } from "src/business/catalog/catalogColumns";
import { CatalogFilters, ZCatalog } from "src/business/catalog/ZCatalog";
import { makeSidLabelsFromKeys, optionsMaker } from "src/common/optionsMaker";
import { MdmDrawer } from "src/components/MdmDrawer";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { ZSidLabel } from "src/types";

type PropsSelectCatalogModal = {
  tableStore?: RtStore<ZCatalog, CatalogFilters>;
  srcSelected: ZSidLabel[];
  close: () => void;
  onApply: (values: ZSidLabel[]) => void;
};

export const SelectCatalogModal: React.FC<PropsSelectCatalogModal> = observer(
  (props) => {
    const { close, tableStore, srcSelected, onApply } = props;

    const makeOption = React.useMemo(
      () => optionsMaker<ZCatalog>(srcSelected, ({ name }) => name),
      [srcSelected],
    );

    if (!tableStore) return null;

    return (
      <MdmDrawer
        title="Выбор каталога"
        open
        onClose={close}
        wide
        extra={
          <Button
            type="primary"
            disabled={tableStore.selectedKeys.length === 0}
            onClick={() => {
              onApply(
                makeSidLabelsFromKeys(tableStore.selectedKeys, makeOption),
              );
              close();
            }}
          >
            Выбрать
          </Button>
        }
      >
        <ToolBox2
          mainTool={<RtSelection store={tableStore} makeOption={makeOption} />}
        >
          <MdmTable
            store={tableStore}
            columns={catalogBaseColumns}
            resizableColumns
          />
        </ToolBox2>
      </MdmDrawer>
    );
  },
);
